import BaseModel from "../../../infraestructure/BaseModel"
export default class CourseSubjectTestQuestionAnswer extends BaseModel {
    constructor(options, state) {
        super(options, state);
    }

    toSend() {
        return {
            id: this.id,
            title: this.title,
            description: this.description,
            sort: this.sort,
            success: this.success,
            updateState: this.updateState,
        }
    }

    updateData(description) {
        this.description = description
        this.updateState = (this.id) ? this.UPDATE_STATUS.UPDATED : this.UPDATE_STATUS.ADDED
    }
}